import React, { useState } from "react";
import {
  Form as CustomForm,
  type FormProps,
  Input,
} from "antd";

import { useSelector } from "react-redux";
import TextArea from "antd/es/input/TextArea";
import LoadingButton from "../../components/LoadingButton";
import _ from "lodash";
import SelectTable from "../../components/formComponents/SelectTable";
import SelectDeviceLocation from "../../components/formComponents/SelectDeviceLocation";
import CustomSelectOptions from "../../components/formComponents/CustomSelectOptions";
import { DEVICE_TYPES } from "../../constants/types";

type EditIotComponentProps = {
  onSubmit: any;
  initialValue?: any;
  loading: boolean;
};

const EditIotComponent: React.FC<EditIotComponentProps> = ({
  onSubmit,
  initialValue,
  loading,
}) => {
  const [form] = CustomForm.useForm();
  const { role } = useSelector((state: any) => state.role);

  const SHOW_RATED_CAPACITY_TYPES = DEVICE_TYPES.filter(device_type => 
    device_type.label === "Inverter" || device_type.label === "Energy System"
  ).map(device_type => device_type.value);

  const [showRatedCapacity, setShowRatedCapacity] = useState(
    SHOW_RATED_CAPACITY_TYPES.includes(initialValue?.device_type)
  );

  return (
    <CustomForm
      form={form}
      name="basic"
      labelCol={{ span: 8 }}
      initialValues={initialValue}
      onValuesChange={(changedValues) => {
        if (changedValues.device_type) {
          setShowRatedCapacity(SHOW_RATED_CAPACITY_TYPES.includes(changedValues.device_type));
        }
      }}
      onFinish={(values: any) => onSubmit(values, form)}
      autoComplete="off"
      layout="vertical"
    >
      <CustomForm.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input name!" }]}
      >
        <Input disabled={form.getFieldValue("imported")} />
      </CustomForm.Item>
      <CustomForm.Item
        label="Location"
        name="location_id"
        rules={[{ required: true, message: "Please input location!" }]}
      >
        <SelectDeviceLocation
          disabled={form.getFieldValue("imported")}
          placeholder="Select Location"
          onChange={(val: any) => {
            form.setFieldValue("location_id", val);
          }}
          value={form.getFieldValue("location_id")}
        />
      </CustomForm.Item>
      <CustomForm.Item
        label="Device Type"
        name="device_type"
        rules={[{ required: true, message: "Please input type!" }]}
      >
        <CustomSelectOptions
          options={DEVICE_TYPES}
          disabled={form.getFieldValue("imported")}
          onChange={(val: any) => form.setFieldValue("device_type", val)}
        />
      </CustomForm.Item>
      {showRatedCapacity && (
        <CustomForm.Item
          label="Rated Capacity"
          name="rated_capacity"
          rules={[
            {
                required: true,
                message: "Please input Rated Capacity!",
            },
          ]}
        >
          <Input
              type="number"
              placeholder="Enter Rated Capacity (kW)"
          />
        </CustomForm.Item>
      )}
      <CustomForm.Item
        label="Manufacture"
        name="manufacture_type"
        rules={[{ required: true, message: "Please input type!" }]}
      >
        <CustomSelectOptions
          options={[
            { value: "1", label: "Huawei" },
            { value: "2", label: "GoodWe" },
            { value: "3", label: "DEDDIE" },
            { value: "4", label: "ReMoni" },
            { value: "30", label: "Custom" },
          ]}
          disabled={form.getFieldValue("imported")}
          onChange={(val: any) => form.setFieldValue("manufacture_type", val)}
        />
      </CustomForm.Item>
      <CustomForm.Item
        label="System"
        name="system_id"
        rules={[{ required: true, message: "Please input system!" }]}
      >
        <SelectTable
          disabled={form.getFieldValue("imported")}
          table="systems"
          placeholder="Select System"
          onChange={(val: any) => form.setFieldValue("system_id", val)}
          value={form.getFieldValue("system_id")}
          multiple
        />
      </CustomForm.Item>

      {!role.role.includes('sub-tenant') && (
        <CustomForm.Item
          label="Assign To"
          name="assign_to"
          rules={[
            { required: false, message: "Please select the assignee!" },
          ]}
        >
          <SelectTable
            placeholder="Select User"
            onChange={(val: any) => form.setFieldValue("assign_to", val)}
            value={form.getFieldValue("assign_to")}
            table="tenantUser"
          />
        </CustomForm.Item>
      )}
      <CustomForm.Item
        label="Description"
        name={"description"}
        rules={[{ required: false, message: "Please input Description!" }]}
      >
        <TextArea rows={1} placeholder="Enter Description" />
      </CustomForm.Item>

      <CustomForm.Item>
        <LoadingButton
          loading={loading}
          title={_.isEmpty(initialValue) ? "Save" : "Update"}
        />
      </CustomForm.Item>
    </CustomForm>
  );
};

export default EditIotComponent;